import { isProdEnvironment } from '@/utils/environment';
import { DigestibleError } from '@/utils/error';
import { datadogRum } from '@datadog/browser-rum';

type ErrorResponse = { message: string };

export const handleFetchError = async (response: Response) => {
  if (!response.ok) {
    if (!isProdEnvironment()) {
      console.error(response.statusText);
    }

    datadogRum.addError(response.statusText);
  }

  return response;
};

export const handleContentfulError = (response: { errors?: ErrorResponse[]; data: unknown }) => {
  if (response.errors?.length) {
    const errorMessage = response.data ? 'Query returned with errors:' : 'Error getting Contentful data:';
    const mappedErrors = response.errors.map((error: ErrorResponse) => error.message).join(';\n');

    if (!response.data) {
      throw new DigestibleError(`${errorMessage}\n${mappedErrors}`, { name: 504 });
    } else {
      if (!isProdEnvironment()) {
        console.error(errorMessage, mappedErrors);
      }

      datadogRum.addError(`${errorMessage}\n${mappedErrors}`);
    }
  }

  return response;
};
